import api from '@pray/shared/utils/api';

export async function getPrayTvSchedule({ artistId, startDate, endDate }: {
  artistId: string;
  startDate: string;
  endDate: string;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!startDate) throw Error('Start Date is required');
  if (!endDate) throw Error('End Date is required');

  const url = `/web/studio/artists/${artistId}/pray-tv-schedule`;
  const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
  const response = await api.executeGetRequest(`${url}?${params.toString()}`);

  return response.data;
}
